import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

new Swiper('.default-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 24,
    loop: true,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
            spaceBetween: 48,
        },
        1024: {
            slidesPerView: 2.25,
        },
        1280: {
            slidesPerView: 2.5,
            spaceBetween: 64,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
});

new Swiper('.image-carousel', {
    slidesPerView: 1.25,
    spaceBetween: 16,
    loop: true,
    centeredSlides: true,
    freeMode: true,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
        },
    },
    navigation: {
        prevEl: '.prev-slide',
        nextEl: '.next-slide',
    },
});

// var customers = new Swiper(".partner-carousel", {
// new Swiper('[data-carousel="partnerCarousel"]', {
// 	spaceBetween: 0,
// 	speed:5000,
// 	direction: 'horizontal',
// 	autoplay: { 
// 		enabled: true,
// 		delay: 0,
// 	},
// 	loop: true,
// 	freeMode: true,
// 	slidesPerView: 'auto',
// 	navigation: {
// 		nextEl: '.swiper-button-next',
// 		prevEl: '.swiper-button-prev',
// 	},
// 	breakpoints: {
// 		200: {
// 			spaceBetween: 40,
//             slidesPerView: 2.5,
// 		},
// 		600: {
// 			spaceBetween: 40,
//             slidesPerView: 2.5,
// 		},
// 		1024: {
// 			spaceBetween: 40,
//             slidesPerView: 3.5,
// 		},
// 		1280: {
// 			spaceBetween: 96,
//             slidesPerView: 4.5,
// 		},
// 	}
// });

new Swiper('[data-carousel="partnerCarousel"]', {
	spaceBetween: 0,
	speed:5000,
	direction: 'horizontal',
	autoplay: { 
		enabled: true,
		delay: 0,
	},
	loop: true,
	freeMode: true,
	slidesPerView: 'auto',
	breakpoints: {
		200: {
			spaceBetween: 40
		},
		600: {
			spaceBetween: 40
		},
		1024: {
			spaceBetween: 40
		},
		1280: {
			spaceBetween: 96
		},
	}
});

new Swiper('[data-carousel="newsSwiper"]', {
    loop: true,
    spaceBetween: 25,
    slidesPerView: 'auto',
    initialSlide: 1,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        3000: {
            spaceBetween: 90,
            initialSlide: 4,
        },
        2600: {
            spaceBetween: 90,
            initialSlide: 3,
        },
        2200: {
            spaceBetween: 90,
            initialSlide: 3,
        },
        1920: {
            spaceBetween: 90,
            initialSlide: 2,
        },
        1680: {
            spaceBetween: 90,
            initialSlide: 2,
        },

        1440: {
            spaceBetween: 90,
            initialSlide: 2,
        },
        1280: {
            spaceBetween: 40,
            initialSlide: 2,
        },
        1024: {
            spaceBetween: 40,
            initialSlide: 1,
        },
        640: {
            spaceBetween: 20,
            initialSlide: 1,
        },
    },
    centeredSlides: true,
});

// const news = new Swiper('.newsSwiper', {
//     loop: true,
//     spaceBetween: 25,
//     slidesPerView: 'auto',
//     initialSlide: 1,
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
//     breakpoints: {
//         768: {
//         spaceBetween: 100,
//         initialSlide: 0,
//         },
//     },
//     centeredSlides: true,


//     // slidesPerView: 1,
//     // spaceBetween: 16,
//     // navigation: {
//     //     nextEl: '.swiper-button-next',
//     //     prevEl: '.swiper-button-prev',
//     // },
//     // breakpoints: {
// 	// 	200: {
// 	// 		// spaceBetween: 40,
//     //         slidesPerView: 1.25,
// 	// 	},
//     //     640: {
//     //         slidesPerView: 1.5,
//     //         // spaceBetween: 16,
//     //     },
//     //     768: {
//     //         slidesPerView: 1.9,
//     //         // spaceBetween: 16,
//     //     },
//     //     1024: {
//     //         slidesPerView: 2.5,
//     //         // spaceBetween: 16,
//     //     },
//     //     1280: {
//     //         slidesPerView: 3.5,
//     //         // spaceBetween: 90,
//     //     },
//     //     1440: {
//     //         slidesPerView: 3.8,
//     //         spaceBetween: 90,
//     //     },

//     //     1680: {
//     //         slidesPerView: 4.5,
//     //         spaceBetween: 90,
//     //     },

//     //     1980: {
//     //         slidesPerView: 5.5,
//     //         spaceBetween: 90,
//     //     },
//     // },
// });

// new Swiper('.partner-carousel', {
//     slidesPerView: 1.25,
//     spaceBetween: 16,
//     loop: true,
//     centeredSlides: true,
//     breakpoints: {
//         768: {
//             slidesPerView: 1.5,
//         },
//     },
//     navigation: {
//         prevEl: '.prev-slide',
//         nextEl: '.next-slide',
//     },
// });
